import { metaMask } from '@wagmi/connectors';
import { createConfig, createStorage, http, injected } from '@wagmi/core';
import { environment } from '../../../environments/environment';

export const config = createConfig({
  chains: [environment.SUPPORTED_NETWORK[0]],
  connectors: [
    metaMask({
      dappMetadata: {
        name: 'aqualux',
        url: environment.PROJECT_URL,
      },
    }), injected()
  ],
  storage: createStorage({ storage: window.localStorage }),
  transports: {
    [environment.SUPPORTED_NETWORK[0].id]: http(environment.PROVIDERS.sepolia)
  },
});